import { useMemo, useCallback } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { permissionList, myTeampermission } from '../constant';
import { resolveOwnerIds } from '../ownerUtils';


export const useDashboardUserScope = () => {
    const currentUser = useSelector(state => state?.owner?.currentuser);
    const ownerlist = useSelector(state => state?.owner?.ownerlist, shallowEqual);
    const myTeam    = useSelector(state => state?.owner?.Team,      shallowEqual);

    // 1. Permission checks
    const isLeadEntireOrg = useMemo(() => 
        currentUser?.authorities?.some(item => item?.authority === permissionList?.ALL_LEAD_MANAGE), 
        [currentUser]
    );
    const isOrderEntireOrg = useMemo(() => 
        currentUser?.authorities?.some(item => item?.authority === permissionList?.ALL_ORDER_MANAGE), 
        [currentUser]
    );
    const isInvoiceEntireOrg = useMemo(() => 
        currentUser?.authorities?.some(item => item?.authority === permissionList?.ALL_INVOICE_MANAGE), 
        [currentUser]
    );
    
    const isEntireOrg = useMemo(() => 
        isLeadEntireOrg || isOrderEntireOrg || isInvoiceEntireOrg, 
        [isLeadEntireOrg, isOrderEntireOrg, isInvoiceEntireOrg]
    );
    const isTeamRequired = useMemo(() => 
        currentUser?.authorities?.some(item => myTeampermission?.includes(item?.authority)), 
        [currentUser]
    );

    // 2. Resolved owner objects array (used for mapping names in reports/bars)
    const resolvedOwners = useMemo(() => {
        if (!currentUser) return [];
        if (isEntireOrg) return ownerlist || [];
        
        if (myTeam?.length === 0 && !isTeamRequired) {
            // Formatted user fallback object
            return [{
                ...currentUser,
                id: currentUser?.userId,
                firstName: currentUser?.firstname,
                lastName: currentUser?.lastname
            }];
        }
        return myTeam || [];
    }, [currentUser, isEntireOrg, ownerlist, myTeam, isTeamRequired]);

    // 3. Helper to generate entity-specific owner query IDs
    const getQueryOwnerIds = useCallback((entityType) => {
        if (!currentUser) return [];
        const allOwnerIds = (ownerlist || []).map(item => item.id);
        const reportingTeamIds = (myTeam || []).map(item => item.id);
        
        let isEntityEntireOrg = false;
        if (entityType === 'lead') isEntityEntireOrg = isLeadEntireOrg;
        else if (entityType === 'order') isEntityEntireOrg = isOrderEntireOrg;
        else if (entityType === 'invoice') isEntityEntireOrg = isInvoiceEntireOrg;

        return resolveOwnerIds({
            isEntireOrg: isEntityEntireOrg,
            allOwnerIds,
            reportingTeamIds,
            currentUserId: currentUser?.userId
        });
    }, [currentUser, ownerlist, myTeam, isLeadEntireOrg, isOrderEntireOrg, isInvoiceEntireOrg]);

    return {
        currentUser,
        ownerlist,
        myTeam,
        isLeadEntireOrg,
        isOrderEntireOrg,
        isInvoiceEntireOrg,
        isEntireOrg,
        isTeamRequired,
        resolvedOwners,
        getQueryOwnerIds
    };
};
